import { Sidebar } from "@components/layout/Sidebar";
import { SidebarNavLink } from "@components/layout/SidebarNavLink";
import { NotFoundPage } from "@components/NotFoundPage";
import { helpCategories } from "@lib/help";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { BarChart3Icon } from "lucide-react";

export const Route = createFileRoute("/help")({
  component: HelpLayout,
  notFoundComponent: () => <NotFoundPage />,
});

function HelpLayout() {
  return (
    <div className="flex flex-1 overflow-hidden">
      <Sidebar className="w-72 shrink-0">
        <div className="flex h-8 items-center">
          <span className="font-medium text-gray-600 text-sm">Help</span>
        </div>
        <nav className="mt-4 space-y-4">
          <div>
            <SidebarNavLink to="/help/completion">
              <BarChart3Icon className="size-4" />
              Completion
            </SidebarNavLink>
          </div>
          {helpCategories.map((category) => (
            <div key={category.label}>
              <span className="px-2 font-medium text-gray-400 text-xs uppercase tracking-wider">
                {category.label}
              </span>
              <div className="mt-1 space-y-1">
                {category.topics.map((topic) => (
                  <SidebarNavLink key={topic.id} to={`/help/${topic.id}`}>
                    <topic.icon className="size-4" />
                    {topic.label}
                  </SidebarNavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </Sidebar>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
